// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"188":"29594a26","358":"50a7756f","685":"4836486a","902":"c6c52fc8","977":"d8d498ff"}[chunkId] + ".css";
};